import { Fragment } from "react";

const DefaultLayout = Fragment

export default DefaultLayout;